<h1 mat-dialog-title>Otros turnos</h1>
<div class="table-scroll"> 
  <table  class="table-content">
    <tr>
      <th class="cell-date">Fecha</th>
      <th class="cell-date">Práctica</th>
      <th class="cell-date">Centro</th>
      <th class="cell-date">Estado</th>
    </tr>

    <tr *ngFor="let reservationSearchItem of data">
      <td class="cell-date">{{reservationSearchItem.DateTime}}</td>
      <td class="cell-date">{{reservationSearchItem.PrincipalPracticeName}}</td>
      <td class="cell-date">{{reservationSearchItem.CenterName}}</td>
      <td class="cell-date">{{reservationSearchItem.StateName}}</td>
    </tr>
  </table>
</div>
<div class="clearfix">
  <div class="pull-right">
    <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Salir</button>
  </div>
</div>
